module.exports = __webpack_public_path__ + "img/公众号.6b9fd862.jpeg";